import React from 'react'

import i18n from 'modules/core/lib/i18n'

import { useItemProvider } from 'modules/processes/components/ItemWizard/Providers/item'
import TaskCard from 'modules/processes/components/ItemWizard/components/ItemCard'
import { DataCollectionCategories } from 'modules/processes/domain'
import { TaskTypes } from 'modules/processes/hooks/types'

interface Props {
  onSelect: (taskType: TaskTypes) => void
}

const Selector = ({ onSelect }: Props) => {
  const { itemType } = useItemProvider()

  return (
    <TaskCard
      title={i18n.t('processes.process_settings.wizard.tasks.types.request_bank_account.title')}
      description={i18n.t(
        'processes.process_settings.wizard.tasks.types.request_bank_account.description'
      )}
      onSelect={() => {
        onSelect(DataCollectionCategories.bankInformation)
      }}
      itemType={DataCollectionCategories.bankInformation}
      value={itemType}
    />
  )
}

export default Selector
